import React from "react";
import queryString from "query-string";
import "./css/greivance.css";
import { Container, Typography, Button } from "@material-ui/core";

import CallToAction from "@material-ui/icons/CallToAction";
import { blue, orange, grey, green, red } from "@material-ui/core/colors";
import { PostData } from "../api/service";
import { Alert, message } from "antd";
import ReceiptPrint from "../Components/ReceiptPrint";

export default function CertificateFeesReponse(props) {
  const [status, setStatus] = React.useState(null);
  const [certificateId, setCertificateId] = React.useState(null);
  const [message, setMessage] = React.useState(false);

  function loadData() {
    let search = props.history.location.search;

    let searchData = queryString.parse(search);

    if (searchData) {
      setStatus(searchData.status);
      setMessage(searchData.message);
      setCertificateId(searchData.certificate_request_id);
    }
  }

  React.useEffect(() => {
    loadData();
  }, []);

  const [receiptData, setReceiptData] = React.useState(null);
  const [isReceiptLoaded, setIsReceiptLoaded] = React.useState(false);

  function loadPaymentData() {
    // check has payment done first

    if (status == "Success" && certificateId != null) {
      // fetch the receipt data by certificate id
      PostData(`/print-receipt-blank`, {
        certificateId: certificateId,
      }).then((resp) => {
        if (resp) {
          setReceiptData(resp);
          setIsReceiptLoaded(true);
        }
      });
    }
  }

  React.useEffect(() => {
    loadPaymentData();
  }, [status, certificateId]);

  return (
    <div>
      <Container>
        <br />
        <br />
        <div className="container">
          <div className="reg-form">
            <div className="top-bar"></div>
            <div className="form-contents">
              <h3
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <div style={{ marginLeft: 10, fontWeight: 700 }}>
                  Fees Payment for Certificate Request
                  <br />
                  <div style={{ fontSize: 16 }}>Dispur College</div>
                </div>
              </h3>
              <hr />

              {status == "Success" && (
                <Alert
                  type="success"
                  banner
                  message={
                    <>
                      <h3>Payment Successfully done</h3>
                      <div>{message}</div>
                    </>
                  }
                />
              )}

              {status == "Failed" && (
                <Alert
                  type="error"
                  banner
                  message={
                    <>
                      <h3>Failed !!</h3>
                      <div>{message}</div>
                    </>
                  }
                />
              )}
            </div>


            {isReceiptLoaded && receiptData && <ReceiptPrint data={receiptData} />}
          </div>
        </div>
      </Container>
    </div>
  );
}
